class AppointmentContactPointNotification {
    public contactPointNotificationList: string[];
    public hasNotificationContactPointSpecified: boolean;
}

export { AppointmentContactPointNotification };
